import React from 'react';
import { MathJax } from "better-react-mathjax";

const Mf = ({children, inline}) =>  {
    return <span className="math"><MathJax inline={inline}>{children}</MathJax></span>;
};
export default Mf;